import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import clsx from "clsx";
import {translations} from "@utils/translations";
import {setFilter} from "../store/actions";
import { IconCross, IconSearch } from './icons';
import styles from "../../../styles/components/searchInput.module.scss";
import SearchSelect from './SearchSelect';

const SearchField = ({params}) => {
    const dispatch = useDispatch();
    const [value, setValue] = useState("");
    const appSettings = useSelector(({rootReducer}) => rootReducer.baseSettings);
    const lang = appSettings.searchLanguage ? appSettings.searchLanguage : "en";

    // eslint-disable-next-line no-unused-vars
    const translate = (s) => translations[lang][s] || s;

    const onPressSearch = () => {
        if (value) {
            dispatch(setFilter(`search=${value}`));
        }
    };

    const resetValue = () => {
        setValue("");
    };

    useEffect(() => {
        setValue(params.selected);
    }, [params]);

    return (
        <>
                <div className={clsx(styles.container, value && styles.active, styles.searchTitle)}>
                    <div className={styles.label}>
                        {translate('search')}
                    </div>
                    <div className={styles.iconWrapper}>
                        <input
                            className={styles.input}
                            data-testid={'searchInput'}
                            type="text"
                            value={decodeURI(value)}
                            onChange={(event) => setValue(event.target.value)}
                            placeholder={translate('search_title_placeholder')}
                        />
                        <button data-testid="searchForm" type="submit"
                                className={styles.search}
                        >
                            <IconSearch />
                        </button>
                    </div>
                </div>
        </>
    );
};

export default SearchField;
